import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import { format } from "date-fns";
import styled from "styled-components";
import GenericTableComponent from "../common/Table";
import { getCampaignPublishers } from "../../redux/slices/reportSlice";
//import { convertToLocalCurrency } from '../../utils/currency';
import { useParams, useLocation } from "react-router-dom";
import BackButton from "../common/BackButton";
import Swal from "sweetalert2";

const columns = [
  { id: "publishername", label: "Publisher" },
  { id: "reach", label: "Clicks" },
  { id: "acquisition", label: "Conversions" },
  { id: "conversionrate", label: "CR" },
  { id: "ecpm", label: "eCPM" },
  { id: "totalconversion", label: "Total conversion" },
  { id: "hoardedconversion", label: "Hoarded conversion"},
];
const CampaignPublishers = () => {
  const { campaignReference } = useParams();
  const dispatch = useDispatch();
  const { campaignPublishers, meta, loading } = useSelector((state) => state.report);
  const location = useLocation();
const searchParams = new URLSearchParams(location.search);
const name = searchParams.get("name");
  
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState(() => {
    const now = new Date();
    return {
      startDate: new Date(now.getFullYear(), now.getMonth(), 1),
      endDate: now,
    };
  });
  const [exportLoading, setExportLoading] = useState(false);
  const [exportData] = useState(true);

  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      const startDate = format(dateRange.startDate, "yyyy-MM-dd");
      const endDate = format(dateRange.endDate, "yyyy-MM-dd");
      dispatch(getCampaignPublishers({ page, rowsPerPage, startDate, endDate, campaignReference }));
    }else {
      dispatch(getCampaignPublishers({ page, rowsPerPage, campaignReference }));
    }
  }, [dateRange, dispatch, page, rowsPerPage, campaignReference ]);

  const handlePageChange = (event, newPage) => {
      setPage(newPage);
  };
  
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const debouncedSearch = useMemo(
    () =>
      debounce((searchTerm) => {
        dispatch(getCampaignPublishers({ page: 0, rowsPerPage, name: searchTerm, campaignReference }));
      }, 2000),
    [dispatch, rowsPerPage, campaignReference]
  );

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearch(value);
    debouncedSearch(value);
  };

  const triggerSearch = () => {
    
    dispatch(getCampaignPublishers({ page: 0, rowsPerPage, name: search, campaignReference }));
  };

  const handleFilterChange = (value) => {
    let boolValue;
    console.log(value);
    if (value === "ACTIVATED") {
      boolValue = true;
    } else if (value === "DEACTIVATED") {
      boolValue = false;
    } else {
      boolValue = null;
    }
    console.log(boolValue);
    dispatch(getCampaignPublishers({ page: 0, rowsPerPage, status: boolValue }));
  };

  const handleExport = async () => {
    try {
      setExportLoading(true);
      
      // Get current date and 7 days ago
      const endDate = dateRange.endDate 
        ? format(dateRange.endDate, "yyyy-MM-dd")
        : format(new Date(), "yyyy-MM-dd");
      
      const startDate = dateRange.startDate 
        ? format(dateRange.startDate, "yyyy-MM-dd")
        : format(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000), "yyyy-MM-dd");
      
      const response = await dispatch(getCampaignPublishers({ 
        startDate, 
        endDate, 
        campaignReference,
        exportData
      })).unwrap();

      // Get the file URL from the response
      if (response.data.file) {
        // Create a temporary link and trigger download
        const link = document.createElement('a');
        link.href = response.data.file;
        link.setAttribute('download', `campaign-publishers-${campaignReference}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        Swal.fire({
          title: 'Export Status',
          text: response.data.message || 'No file available for download',
          icon: 'info',
          confirmButtonColor: '#03a9f4'
        });
      }
    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        title: 'Export Failed',
        text: error.message || 'Failed to export campaign details',
        icon: 'error',
        confirmButtonColor: '#03a9f4'
      });
    } finally {
      setExportLoading(false);
    }
  };

  // const handleActiveState = (id) => {
  //   dispatch(statusAdvertiser(id))
  //   .unwrap()
  //   .then(() => {
  //     dispatch(getCampaignPublishers({ page, rowsPerPage }));
  //   })
  //   .catch((error) => {
  //     console.error("Failed to update advertiser status:", error);
  //   });
  // };

  return (
    <Container>
      <BackButton></BackButton>
      <div className="header">
        <div className="texts">
          <h3>{name}</h3>
          <p>View all publishers.</p>
        </div>

        <div className="link-buttons">
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          {/* <Link className="add-campaign" to="/create-publisher">
            + Create campaign
          </Link> */}
        </div>
      </div>

      {loading ? (
        <div> </div>
      ) : (
        <GenericTableComponent
          columns={columns}
          data={campaignPublishers}
          filterSearch={true}
          paginate={true}
          viewLink="/view-publisher"
          editLink="/edit-publisher"
          page={page}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          triggerSearch={triggerSearch}
          search={search}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handleSearchChange={handleSearchChange}
          totalItems={meta?.itemCount || 0}
          onFilterChange={handleFilterChange}
          //hideDateSearch
          hideActiveSearch
          hideSearch
          postbackView
          setDateRange={setDateRange}
          dateRange={dateRange}
          showExport={true}
          onExport={handleExport}
          exportLoading={exportLoading}
          //handleActiveState={handleActiveState}
        />
      )}
    </Container>
  );
};

export default CampaignPublishers;

export const Container = styled.div`
padding: 20px;
  background: linear-gradient(135deg, #f5f9fc 0%, #ffffff 100%);
  min-height: 100vh;
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 15px;
        color: #1a237e;
      }
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
        font-size: 32px;
        line-height: 44px;
        color: #1a237e;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .add-campaign {
        color: #fff;
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
`;